import {
  Box,
  Flex,
  Heading,
  Skeleton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useToast,
} from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { Route, useHistory, useRouteMatch } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  dashboardRoutePadding,
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { ServicerReportsTable } from 'packages/reporting/ui/ServicerReportsTable';
import { ReportsTable } from 'packages/reports/ui/ReportsTable';

import 'source/borrower/borrower.scss';

export const ReportsRoute = () => {
  const { path } = useRouteMatch();
  const toast = useToast();
  const history = useHistory();

  const { data: userData, loading: userLoading } = useGetUserQuery();
  const { creditFacilityId } = useCreditFacilityContext();

  if (userLoading || !userData) {
    return <Skeleton data-testid="loading-reports-view" height="600px" />;
  }

  const { user } = userData;

  // Use this variable for errors that bubble up to the component level route
  // This ensures we only toast the error once when there are multiple errors
  // We should use Chakra's toast.isActive, or a react hook in general, but the state re-renders when there are multiple errors in a given error boundary
  let routeLevelError = false;
  return (
    <Box padding={dashboardRoutePadding}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load reports page in capital provider dashboard`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <Route exact path={path}>
          <Flex justify="space-between">
            <Heading>Reports</Heading>
            <Box>
              <CreditFacilitySelect organizationId={user?.organizationId} />
            </Box>
          </Flex>
          <Tabs variant="line" colorScheme="black">
            <TabList>
              <Tab>Reports</Tab>
              <Tab>Servicer Reports</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <ReportsTable creditFacilityId={creditFacilityId} />
              </TabPanel>

              <TabPanel>
                <ServicerReportsTable creditFacilityId={creditFacilityId} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Route>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
